<template>
  <div v-if="showDonateBtn()" class="d-inline-block float-right">
    <v-dialog
      width="500px"
      flat
      scrollable
      height="400px"
      persistent
      :value="donationDialog"
    >
      <v-card>
        <v-card-title class="headline primary background--text" primary-title>
          {{ $t("donate.title") }}
          <v-spacer></v-spacer>
          <v-btn @click="resetDialog">close</v-btn>
        </v-card-title>
        <v-card-text>
          {{ $t("donate.subtitle") }}
        </v-card-text>
        <v-card-text class="pt-0">
          {{ screener.donation.purpose }}
        </v-card-text>
        <v-card-text class="text-xs-center">
          <form
            @submit="resetDialog"
            :action="DEFINES.PAYPAL_DONATION_URL"
            method="post"
            target="_blank"
          >
            <input
              type="hidden"
              name="business"
              :value="screener.donation.email"
            />
            <input
              type="hidden"
              name="item_name"
              :value="screener.donation.purpose"
            />
            <input
              type="hidden"
              name="currency_code"
              :value="company.currency"
            />
            <input type="hidden" name="return" :value="returnUrl()" />
            <input
              type="image"
              src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
              border="0"
              name="submit"
              title="PayPal - The safer, easier way to pay online!"
              alt="Donate with PayPal button"
            />
            <img
              alt=""
              border="0"
              src="https://www.sandbox.paypal.com/en_US/i/scr/pixel.gif"
              width="1"
              height="1"
            />
            <input type="hidden" name="charset" value="utf-8">
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import DEFINES from "@/defines";

export default {
  name: "PayPalDonation",
  props: ["donationDialog", "screener"],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      company: (state) => state.company.company,
    }),
  },
  methods: {
    showDonateBtn() {
      return (
        this.screener && this.screener.donation_enabled
      );
    },

    resetDialog() {
      this.$emit("resetDonationDialog");
    },

    returnUrl() {
      const resolved = this.$router.resolve({
        name: "user.dashboard",
      });
      return (
        window.location.protocol + "//" + window.location.host + resolved.href
      );
    },
  },
};
</script>
